import { useCmsHashState } from '../../../hooks/useHashState';

type CentralModalsState = {
  errorModalOpen: string;
  confirmationModalOpen: string;
};

export const useCentralModals = () => {
  const [params, setHashParams] = useCmsHashState<CentralModalsState>({
    errorModalOpen: 'string',
    confirmationModalOpen: 'string',
  });

  const isErrorOpen = params.errorModalOpen === 'true';
  const isConfirmationOpen = params.confirmationModalOpen === 'true';

  const openErrorModal = () => setHashParams({ errorModalOpen: 'true' });
  const closeErrorModal = () => setHashParams({ errorModalOpen: undefined });

  const openConfirmationModal = () =>
    setHashParams({ confirmationModalOpen: 'true' });
  const closeConfirmationModal = () =>
    setHashParams({ confirmationModalOpen: undefined });

  const toggleErrorModal = () => {
    if (isErrorOpen) closeErrorModal();
    else openErrorModal();
  };

  const toggleConfirmationModal = () => {
    if (isConfirmationOpen) closeConfirmationModal();
    else openConfirmationModal();
  };

  return {
    isErrorOpen,
    isConfirmationOpen,
    openErrorModal,
    closeErrorModal,
    toggleErrorModal,
    openConfirmationModal,
    closeConfirmationModal,
    toggleConfirmationModal,
  };
};
